module.exports = __webpack_public_path__ + "static/media/health.d52cf48b.jpg";